import { ItemFieldPartTemplate } from './ItemFieldPartTemplate';

export class ItemOverviewBodyFieldTemplate {
    public readonly parts: ItemFieldPartTemplate[];
    constructor(readonly template: string, readonly cssClass: string) {
        const parts = template.split(/\{([a-zA-Z]+)\}/g);
        this.parts = parts.map((v, index) => {
            if (index % 2 == 0) {
                if (!v) {
                    return undefined;
                }
                return new ItemFieldPartTemplate('', v);
            }
            switch (v) {
                case 'id':
                case 'title':
                case 'index':
                case 'pointsGained':
                case 'pointsPending':
                case 'pointsLost':
                case 'pointsMax':
                case 'pointsPercent':
                case 'score':
                    return new ItemFieldPartTemplate(v, '');
                default:
                    return new ItemFieldPartTemplate('', v);
            }
        }).filter(x => !!x);
    }
}
